import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Document } from '../../../interfaces/customer-api';
import css from './StockEquipmentDocuments.module.scss';
import PictureIcon from '../../assets/picture-icon.svg';
import { Lightbox } from '../Lightbox/Lightbox';
import { PictureItem } from './PictureItem';

const PICTURES_INITIAL_COUNT = 3;

export interface PicturesSectionProps {
    docs: Document[];
}

export const PicturesSection: React.FC<PicturesSectionProps> = ({ docs }) => {
    const { t } = useTranslation('StockEquipment');
    const [showAllPictures, setShowAllPictures] = useState(false);
    const [lightbox, setLightbox] = useState<{ pics: Document[]; index: number } | null>(null);

    const visiblePictures = showAllPictures ? docs : docs.slice(0, PICTURES_INITIAL_COUNT);

    return (
        <div className={css.document}>
            <PictureIcon />
            <h4>{t('Pictures')}</h4>
            <div className={css.pictureGallery}>
                {visiblePictures.map((doc, index) => (
                    <PictureItem
                        key={doc.key}
                        doc={doc}
                        onClick={() => setLightbox({ pics: docs, index })}
                    />
                ))}
            </div>
            {docs.length > PICTURES_INITIAL_COUNT && (
                <button className={css.showMoreButton} onClick={() => setShowAllPictures((prev) => !prev)}>
                    {showAllPictures ? t('Show less') : t('Show more')}
                </button>
            )}
            {lightbox && (
                <Lightbox pics={lightbox.pics} initialIndex={lightbox.index} onClose={() => setLightbox(null)} />
            )}
        </div>
    );
};
